<template>
  <section v-if="newsList.length != 0" id="noticias" class="secciones seccion-blanca text-center">
    <div class="container">
      <h1><strong>Tu Comunidad</strong></h1>
      <p>Noticias y Blog de Armaq.</p>
      <router-link :to="'/comunidad'" class="btn-al btn-al-lg btn-al-celeste-solid btn-secciones"
        ><span>Ver Todas</span></router-link
      >
      <div class="row">
        <div class="col-lg-6" v-for="(item, index) in newsList" :key="index">
          <div class="noticias">
            <router-link :to="'/comunidad/' + item.id_news" class="noticias-foto">
              <img
                v-bind:src="imgPreUrl + item.url_main_image + 'x320.jpg'"
                v-bind:alt="item.title_news_es"
                class="imagen-cover"
              />
            </router-link>
            <div class="noticias-contenido">
              <div class="noticias-fecha">
                <strong>{{ item.date_new | esDate }}</strong>
              </div>
              <div class="noticias-titulo">
                <h2>
                  <strong>{{ item.title_news_es }}</strong>
                </h2>
              </div>
              <div class="noticias-texto">
                <p>{{ (item.desc_news_es.substring(0, 70) + '...') | striphtml }}</p>
              </div>
            </div>
            <router-link
              :to="'/comunidad/' + item.id_news"
              class="btn-al btn-al-sm btn-al-celeste-solid noticias-boton"
              >SEGUIR LEYENDO</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getNews } from '@/service/news.service.js';
import { config_settings } from '@/config.js';

export default {
  name: 'NewsModule',
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      newsList: [],
    };
  },
  methods: {
    getNewsService() {
      getNews()
        .then((response) => {
          this.newsList = response.data.news;
          if (this.newsList.length > 4) {
            this.newsList.pop();
          }
        })
        .catch((error) => {});
    },
  },
  created() {
    this.getNewsService();
  },
};
</script>
